import { render, staticRenderFns } from "./DashboardTs.vue?vue&type=template&id=5a76dfd2&scoped=true&"
import script from "./DashboardTs.vue?vue&type=script&lang=ts&"
export * from "./DashboardTs.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardTs.vue?vue&type=style&index=0&id=5a76dfd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a76dfd2",
  null
  
)

export default component.exports